import { Dispatch, FC, ReactNode, SetStateAction, createContext, useContext } from "react";

type EditorContentPermissionType = {
  customId: string;
  permissions: string;
};

type EditorContentPermissionContextType<T extends {} = {}> = T & {
  contentPermissions: EditorContentPermissionType[];
  setContentPermission: Dispatch<SetStateAction<EditorContentPermissionType[]>>;
};

const EditorContentPermissionContext = createContext<EditorContentPermissionContextType>({
  contentPermissions: [],
  setContentPermission: () => "",
});

interface IEditorContentPermissionProps {
  context: EditorContentPermissionContextType;
  children: ReactNode;
}

const EditorContentPermissionContextProvider: FC<IEditorContentPermissionProps> = (props) => {
  const { context, children } = props;
  return (
    <EditorContentPermissionContext.Provider value={context}>
      <div className="row px-0 mx-0">{children}</div>
    </EditorContentPermissionContext.Provider>
  );
};

const useEditorContentPermission = <T extends {} = {}>() => {
  const ctx = useContext<EditorContentPermissionContextType<T>>(EditorContentPermissionContext as any);

  if (!ctx) {
    throw new Error("useProcess must be using in ProcessContext.Provider");
  }
  return ctx;
};

export { EditorContentPermissionContextProvider, useEditorContentPermission };
export type { EditorContentPermissionType, EditorContentPermissionContextType };
